import { memo, useState } from 'react';

import ActivitiesList from './list';
import ActivitiesSearch from './search';
import ActivitiesSearchresult from './searchresult';
import ActivitiesStatus from './status';

import { activitiessearchTypes, activitiesTypes } from '../../../types';
import { checkPaginationCallFn } from '../../../utils/helpers';
import { pageSize } from '../../../utils/constants';
import { useSetBreadcrumb } from 'src/shared/hooks';

interface propsTypes extends activitiessearchTypes {
  activities: activitiesTypes;
  getActivitiesPlanholders: any;
  setActivitiesDetails: any;
}

function Downloads(props: propsTypes) {
  const { activities, getActivitiesPlanholders, setActivitiesDetails } = props;
  const {
    activities_planholders,
    planholders_internalLoader,
    activitiesSearch,
    activities_planholders_search,
    planholderStatus,
  } = activities;
  const { /* page,*/ result: planholderslist, /*size,*/ total } = activities_planholders;
  const { /* page,*/ result: planholderslist_search, /*size,*/ total: total_search } =
    activities_planholders_search;

  const totalCount = activitiesSearch ? total_search : total;

  useSetBreadcrumb({
    page: 'Activities',
    altname: 'Downloads',
    title: 'Downloads',
    name: 'Downloads',
    menuactive: 'activities',
  });

  // Logic for displaying pagination
  const [currentPages, setCurrentPages] = useState(1);
  const listPerPages = pageSize.default;
  const indexOfLastLists = currentPages * listPerPages;
  const indexOfFirstLists = indexOfLastLists - listPerPages;

  const onPagingClick = (value: number) => {
    if (value !== currentPages) {
      if (checkPaginationCallFn(value, listPerPages, planholderslist, total)) {
        getActivitiesPlanholders({
          page: Math.ceil(value / listPerPages) + 1,
          size: 100,
          pagination: true,
        });
      }
      setCurrentPages(Number(value));
    }
  };

  const onSelectChange = (name: any, value: any) => {
    setActivitiesDetails({ planholderStatus: value });
  };

  const finalplanholderslist = planholderslist.slice(indexOfFirstLists, indexOfLastLists) || [];

  return (
    <>
      <div className='row'>
        <div className='col-lg-12'>
          <h2 className='arrowWrapper'>Downloads ({totalCount})</h2>
          <ActivitiesStatus
            {...props}
            pagefor='planholders'
            onSelectChange={onSelectChange}
            status={planholderStatus}
            setCurrentPages={setCurrentPages}
          />
        </div>
      </div>
      <div className='row'>
        <ActivitiesSearch {...props} pagefor='planholders' setCurrentPages={setCurrentPages} />
      </div>
      {activitiesSearch ? (
        <ActivitiesSearchresult
          {...props}
          activitieslist={planholderslist_search}
          total={total_search}
          pagefor='planholders'
        />
      ) : (
        <ActivitiesList
          {...props}
          pagefor='planholders'
          InternalLoader={planholders_internalLoader}
          loadermsg='No Planholders Available'
          list={planholderslist}
          finallist={finalplanholderslist}
          total={total}
          currentPages={currentPages}
          onPagingClick={onPagingClick}
          listPerPages={listPerPages}
        />
      )}
    </>
  );
}

export default memo(Downloads);
